export default "__VITE_ASSET__9hn6VhEs__"